// Lumin · Carrusel (OS 2.0) — FINAL estable: translateX + límites + sync dots/arrows + force-load imgs
(function () {
  const qs  = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => Array.from(c.querySelectorAll(s));
  const vw  = () => Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  /* ===== Config desde data-attrs ===== */
  function slidesPerView(root) {
    const d = Number(root.dataset.slidesDesktop || 3);
    const t = Number(root.dataset.slidesTablet  || 2);
    const m = Number(root.dataset.slidesMobile  || 1);
    const width = vw();
    if (width < 768) return m;
    if (width < 1024) return t;
    return d;
  }
  function getTrackGapPx(root) {
    const track = qs('.lumin-track', root);
    const cs = window.getComputedStyle(track);
    return parseFloat(cs.gap || cs.columnGap || '0') || 0;
  }
  function setItemBasis(root) {
    const per   = (root.__perPage = slidesPerView(root));
    const track = qs('.lumin-track', root);
    const gap   = getTrackGapPx(root);
    const basis = `calc((100% - ${(per - 1) * gap}px) / ${per})`;
    qsa('.lumin-card', track).forEach(el => {
      el.style.flexBasis  = basis;
      el.style.flexGrow   = '0';
      el.style.flexShrink = '0';
    });
    return per;
  }
  function totalItems(root){ return qsa('.lumin-card', root).length; }
  function pageCount(root){
    const items = totalItems(root);
    const per   = root.__perPage || slidesPerView(root) || 1;
    return Math.max(1, Math.ceil(items / per));
  }

  /* ===== Métricas robustas ===== */
  function trackWidthByCards(track){
    const cards = qsa('.lumin-card', track);
    if (!cards.length) return track.scrollWidth || track.getBoundingClientRect().width || 0;
    const last = cards[cards.length - 1];
    const rectLast  = last.getBoundingClientRect();
    const rectTrack = track.getBoundingClientRect();
    return rectLast.right - rectTrack.left;
  }

  /* ===== Carga forzada de imágenes visibles (lazy + transform bug) ===== */
  function forceLoadImagesInView(root){
    const viewport = qs('.lumin-viewport', root);
    const vwRect = viewport.getBoundingClientRect();
    // cards visibles dentro del viewport
    qsa('.lumin-card', root).forEach(card => {
      const rc = card.getBoundingClientRect();
      const visible = rc.right > vwRect.left && rc.left < vwRect.right;
      if (!visible) return;
      qsa('img', card).forEach(img => {
        try {
          if (img.loading === 'lazy') img.loading = 'eager';
          if (img.dataset && img.dataset.src && !img.src) img.src = img.dataset.src;
          if (img.dataset && img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
          // si hay <source> en picture con data-srcset:
          const pic = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
          if (pic){
            qsa('source', pic).forEach(s => {
              if (s.dataset && s.dataset.srcset && !s.srcset) s.srcset = s.dataset.srcset;
            });
          }
          if (img.decode) img.decode().catch(()=>{});
        } catch(e) {}
      });
    });
  }

  /* ===== Snap con translateX y límite (evita “blanco”) ===== */
  function snapToPage(root){
    const viewport = qs('.lumin-viewport', root);
    const track    = qs('.lumin-track', root);
    const cards    = qsa('.lumin-card', track);
    const per      = root.__perPage || slidesPerView(root);
    const pages    = Math.max(1, Math.ceil(cards.length / per));
    const page     = Math.max(0, Math.min(root.__page || 0, pages - 1));
    const idx      = page * per;
    const card     = cards[idx];
    if (!card) return;

    // desactiva transform para medir offset puro
    const prev = track.style.transform;
    track.style.transform = 'none';

    // offset del card respecto al track
    const offset   = card.offsetLeft;
    const vpWidth  = viewport.clientWidth;
    const tw       = Math.max(trackWidthByCards(track), track.scrollWidth, track.getBoundingClientRect().width);
    const maxOff   = Math.max(0, tw - vpWidth);
    const EPS      = 1;
    const target   = Math.min(Math.max(0, Math.round(offset)), Math.max(0, Math.round(maxOff - EPS)));

    track.style.transform = prev;
    track.style.transform = `translateX(${-target}px)`;

    // fuerza carga de imágenes visibles tras el snap
    // 1) inmediato
    forceLoadImagesInView(root);
    // 2) tras el siguiente frame (al iniciar la transición)
    requestAnimationFrame(() => forceLoadImagesInView(root));
    // 3) al finalizar la transición de transform
    const onEnd = (ev) => {
      if (ev && ev.propertyName && ev.propertyName !== 'transform') return;
      try { forceLoadImagesInView(root); } catch(_) {}
      track.removeEventListener('transitionend', onEnd);
    };
    track.addEventListener('transitionend', onEnd);
  }

  /* ===== Dots / Arrows ===== */
  function updateDots(container, root){
    if (!container) return;
    const buttons = qsa('button', container);
    buttons.forEach((b, i) => b.setAttribute('aria-current', (root.__page === i) ? 'true' : 'false'));
  }
  function buildDots(container, root){
    if (!container) return;
    container.innerHTML = '';
    const per   = root.__perPage || slidesPerView(root);
    const items = totalItems(root);
    const pages = Math.max(1, Math.ceil(items / per));
    if (items <= per || pages <= 1){
      container.style.display = 'none';
      root.classList.add('is-single-page');
      return;
    }
    container.style.display = '';
    root.classList.remove('is-single-page');
    for (let i = 0; i < pages; i++){
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Ir a página ${i + 1}`);
      b.addEventListener('click', () => {
        root.__page = i;
        snapToPage(root);
        updateDots(container, root);
        // asegurar carga en móvil/tablet al finalizar animación
        const track = qs('.lumin-track', root);
        const after = () => { try { forceLoadImagesInView(root); } catch(_) {} track.removeEventListener('transitionend', after); };
        track.addEventListener('transitionend', after, { once: true });
        // fallback por si no se dispara transitionend
        setTimeout(() => { try { forceLoadImagesInView(root); } catch(_) {} }, 420);
      });
      container.appendChild(b);
    }
    updateDots(container, root);
  }
  function updateNavVisibility(root){
    const prev = qs('.lumin-prev', root);
    const next = qs('.lumin-next', root);
    const per  = root.__perPage || slidesPerView(root);
    const show = totalItems(root) > per;
    if (prev) prev.style.display = show ? '' : 'none';
    if (next) next.style.display = show ? '' : 'none';
    if (!show) root.classList.add('is-single-page'); else root.classList.remove('is-single-page');
  }
  function bindNav(root){
    const prev = qs('.lumin-prev', root);
    const next = qs('.lumin-next', root);
    if (!prev && !next) return;
    const go = dir => {
      const pages = pageCount(root);
      root.__page = Math.max(0, Math.min((root.__page || 0) + dir, pages - 1));
      snapToPage(root);
      const dots = root.parentElement.querySelector('.lumin-dots');
      if (dots) updateDots(dots, root);
    };
    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
  }

  /* ===== Add to cart ===== */
  function bindATC(section){
    qsa('.lumin-atc', section).forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.dataset.variantId;
        if (!id) return;
        btn.disabled = true;
        const original = btn.textContent;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, quantity: 1 })
          });
          btn.textContent = 'Agregado ✓';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
          document.dispatchEvent(new CustomEvent('lumin:atc', { detail: { variantId: id } }));
        } catch (e) {
          btn.textContent = 'Error';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
        }
      });
    });
  }


/* ===== Swipe mínimo (touch) ===== */
function bindSwipe(root){
  const viewport = qs('.lumin-viewport', root);
  if (!viewport) return;

  let sx = 0, sy = 0, st = 0;

  viewport.addEventListener('touchstart', (e) => {
    if (!e.touches || !e.touches[0]) return;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
    st = Date.now();
  }, { passive: true });

  viewport.addEventListener('touchend', (e) => {
    if (!e.changedTouches || !e.changedTouches[0]) return;

    const ex = e.changedTouches[0].clientX;
    const ey = e.changedTouches[0].clientY;

    const dx = ex - sx;
    const dy = ey - sy;
    const dt = Date.now() - st;

    // Reglas: gesto horizontal claro + distancia mínima
    if (Math.abs(dx) < 35) return;
    if (Math.abs(dx) < Math.abs(dy)) return;

    const pages = pageCount(root);
    if (pages <= 1) return;

    // Swipe rápido o largo -> cambia de página
    // dx < 0 => swipe izquierda => NEXT
    // dx > 0 => swipe derecha  => PREV
    if (dx < 0) root.__page = Math.min((root.__page || 0) + 1, pages - 1);
    else        root.__page = Math.max((root.__page || 0) - 1, 0);

    snapToPage(root);

    const sectionEl = root.closest('.lumin-featured');
    const dots = sectionEl ? sectionEl.querySelector('.lumin-dots') : null;
    if (dots) updateDots(dots, root);

    forceLoadImagesInView(root);
  }, { passive: true });
}



  /* ===== Init / destroy ===== */
  function initSection(sectionEl){
    const root = qs('.lumin-carousel', sectionEl);
    if (!root) return;

    setItemBasis(root);
    root.__page = 0;

    const dots = sectionEl.querySelector('.lumin-dots');
    if (root.dataset.showDots === 'true') buildDots(dots, root);
    else if (dots) dots.style.display = 'none';

    bindNav(root);
    bindSwipe(root);
    updateNavVisibility(root);
    bindATC(sectionEl);

    // primer snap y carga de imágenes visibles
    requestAnimationFrame(() => {
      snapToPage(root);
      forceLoadImagesInView(root);
    });

    // autoplay (sólo si hay más de una página)
    const doAutoplay = root.dataset.autoplay === 'true';
    const startAutoplay = () => {
      const per = root.__perPage || 1;
      if (!doAutoplay || totalItems(root) <= per) return;
      const delay = Number(root.dataset.autoplayMs || 5000);
      root.__timer = setInterval(() => {
        const pages = pageCount(root);
        if (pages <= 1) return;
        root.__page = ((root.__page || 0) + 1) % pages;
        snapToPage(root);
        if (dots) updateDots(dots, root);
        forceLoadImagesInView(root);
      }, delay);
    };
    startAutoplay();

    root.addEventListener('mouseenter', () => { if (root.__timer) clearInterval(root.__timer); });
    root.addEventListener('mouseleave', () => {
      if (root.__timer) clearInterval(root.__timer);
      startAutoplay();
    });

    root.__resize = () => {
      const oldPer = root.__perPage;
      const nowPer = setItemBasis(root);
      if (dots && (oldPer !== nowPer)) buildDots(dots, root);
      updateNavVisibility(root);
      snapToPage(root);
      forceLoadImagesInView(root);
    };
    window.addEventListener('resize', root.__resize);
    window.addEventListener('orientationchange', () => setTimeout(root.__resize, 250));

    // cuando carguen imágenes internas, re-snap + force-load
    qsa('img', root).forEach(img => {
      if (img.complete) return;
      img.addEventListener('load', () => {
        setItemBasis(root);
        if (dots && root.dataset.showDots === 'true') buildDots(dots, root);
        updateNavVisibility(root);
        snapToPage(root);
        forceLoadImagesInView(root);
      }, { once: true });
    });

    // al terminar de cargar todo (fuentes, etc.)
    window.addEventListener('load', () => {
      root.__resize();
      forceLoadImagesInView(root);
    }, { once: true });
  }

  function destroySection(sectionEl){
    const root = qs('.lumin-carousel', sectionEl);
    if (!root) return;
    if (root.__timer) clearInterval(root.__timer);
    if (root.__resize) window.removeEventListener('resize', root.__resize);
  }

  function boot(){ qsa('.lumin-featured').forEach(initSection); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', e => { if (e.target.matches('.lumin-featured')) initSection(e.target); });
  document.addEventListener('shopify:section:unload', e => { if (e.target.matches('.lumin-featured')) destroySection(e.target); });

  // Asegura carga de imágenes visibles tras navegar con dots/flechas en el siguiente frame (iOS/Safari)
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const isDot   = !!t.closest('.lumin-dots button');
    const isArrow = !!t.closest('.lumin-nav');
    if (!isDot && !isArrow) return;
    const section = t.closest('.lumin-featured');
    if (!section) return;
    const root = section.querySelector('.lumin-carousel');
    if (!root) return;
    requestAnimationFrame(() => { try { forceLoadImagesInView(root); } catch(_) {} });
  });
})();
